<sepidz-review [showAllDays]="showAllDays" [hasIncludeTime]="true" class="review">
  <div review-filters class="filters">
    <div>
      <div *ngIf="isDepositReview" class="deposit-date-filter">
        <span>{{ "ClientApp.FrontOffice.Review.SalesReview.FilterRegistrationDate" | translate }}</span>
        <ssg-swichbox (valueChange)="applyDepositDateFilter()" [check]="filterByDepositCreatedDate">{{
          "ClientApp.FrontOffice.Review.SalesReview.FilterRegistrationDate" | translate
        }}</ssg-swichbox>
      </div>
      <div class="cardbody">
        <sepidz-static-select-review
          valueType="boolean"
          [form]="formGroup"
          [title]="'ClientApp.FrontOffice.Review.SalesReview.IncludeCancelled' | translate"
          name="IncludeCancelled"
          key="IncludeCancelled"
          [items]="[{ Name: 'ClientApp.FrontOffice.Review.SalesReview.IncludeCancelled' | translate, Value: true }]">
        </sepidz-static-select-review>
      </div>
    </div>
    <div class="listbox">
      <div class="titleheader" *ngIf="isMultiBranch">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Branch" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('GoodsGroup')">
          <span class="name"> {{ "ClientApp.FrontOffice.Review.SalesReview.GoodsGroup" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'GoodsGroup'"></i>
        </div>
        <div *ngIf="selected === 'GoodsGroup'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.GoodsGroup' | translate"
            [form]="formGroup"
            name="ItemCategory"
            key="ItemCategoryIds"
            apiName="ItemCategory/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('User')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.User" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'User'"></i>
        </div>
        <div *ngIf="selected === 'User'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.User' | translate"
            [form]="formGroup"
            textFieldName="DisplayName"
            name="UserList"
            key="UserListIds"
            apiName="Authorization/GetUserList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('SaleMethod')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.SaleMethod" | translate }} </span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'SaleMethod'"></i>
        </div>
        <div *ngIf="selected === 'SaleMethod'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            title="ClientApp.FrontOffice.Review.SalesReview.SaleMethod"
            [form]="formGroup"
            name="Title"
            key="SaleMethodIds"
            apiName="SaleMethod/ReadSaleMethodLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('Waiter')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Waiter" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Waiter'"></i>
        </div>
        <div *ngIf="selected === 'Waiter'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Waiter' | translate"
            [form]="formGroup"
            textFieldName="DisplayName"
            name="WaiterList"
            key="WaiterListIds"
            apiName="Personnel/GetWaiterList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('Delivery')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Delivery" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Delivery'"></i>
        </div>
        <div *ngIf="selected === 'Delivery'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Delivery' | translate"
            [form]="formGroup"
            textFieldName="DisplayName"
            name="DriverIds"
            key="DriverIds"
            apiName="Personnel/GetDriverPersonnel">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('SalePrice')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.SalePrice" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'SalePrice'"></i>
        </div>
        <div *ngIf="selected === 'SalePrice'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.SalePrice' | translate"
            [form]="formGroup"
            name="SalePriceType"
            key="SalePriceTypeIds"
            apiName="SalePriceType/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Factor')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.InvoiceStatus" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Factor'"></i>
        </div>
        <div *ngIf="selected === 'Factor'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceStatus' | translate"
            [form]="formGroup"
            name="InvoiceStatus"
            key="InvoiceStatusIds"
            apiName="Lookup"
            systemName="SALE"
            category="InvoiceStatus">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('Salon')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Salon" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Salon'"></i>
        </div>
        <div *ngIf="selected === 'Salon'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Salon' | translate"
            [form]="formGroup"
            name="SalonId"
            key="SalonIds"
            apiName="Salon/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('accountstatus')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.AccountStatus" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'accountstatus'"></i>
        </div>
        <div *ngIf="selected === 'accountstatus'">
          <sepidz-remote-select-review
            [form]="formGroup"
            key="accountstatus"
            name="accountstatus"
            [items]="[
              { Id: 1, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.Debit' | translate },
              { Id: 2, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.Credit' | translate },
              { Id: 3, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.UseCredit' | translate },
              { Id: 4, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.LinkPayment' | translate },
              { Id: 5, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.Online' | translate },
              { Id: 6, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.Snap' | translate },
              { Id: 7, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.OrganizationalDiscount' | translate }
            ]">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('SMSType')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.SMSType" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'SMSType'"></i>
        </div>
        <div *ngIf="selected === 'SMSType'">
          <sepidz-remote-select-review
            [form]="formGroup"
            key="SMSType"
            name="SMSType"
            [items]="[
              { Id: 1, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.InvoiceLink' | translate },
              { Id: 2, Selected: false, Title: 'ClientApp.FrontOffice.Review.SalesReview.PaymentLink' | translate }
            ]">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('PaymentState')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.PaymentState" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'PaymentState'"></i>
        </div>
        <div *ngIf="selected === 'PaymentState'">
          <sepidz-remote-select-review [form]="formGroup" key="PaymentState" name="PaymentState" [items]="paymentStates">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="!isDepositReview">
        <div class="title" (click)="setSelectedFilter('PaymentMethod')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.PaymentMethod" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'PaymentMethod'"></i>
        </div>
        <div *ngIf="selected === 'PaymentMethod'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.PaymentMethodType' | translate"
            [form]="formGroup"
            name="PaymentMethod"
            key="PaymentMethod"
            apiName="Lookup"
            systemName="SALE"
            category="PaymentMethodType">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="isDepositReview">
        <div class="title" (click)="setSelectedFilter('MealTime')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.MealTime" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'MealTime'"></i>
        </div>
        <div *ngIf="selected === 'MealTime'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.MealTime' | translate"
            [form]="formGroup"
            name="MealTime"
            key="MealTime"
            textFieldName="Title"
            [items]="MealTimeDataList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="isDepositReview">
        <div class="title" (click)="setSelectedFilter('DeliveryType')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.DeliveryType" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'DeliveryType'"></i>
        </div>
        <div *ngIf="selected === 'DeliveryType'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.DeliveryType' | translate"
            [form]="formGroup"
            name="DeliveryType"
            key="DeliveryType"
            textFieldName="Title"
            [items]="DeliveryTypeDataList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="isDepositReview">
        <div class="title" (click)="setSelectedFilter('ClearType')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.ClearType" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'ClearType'"></i>
        </div>
        <div *ngIf="selected === 'ClearType'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.ClearType' | translate"
            [form]="formGroup"
            name="ClearType"
            key="ClearType"
            textFieldName="Title"
            [items]="ClearTypeDataList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="isDepositReview">
        <div class="title" (click)="setSelectedFilter('Cook')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Cook" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Cook'"></i>
        </div>
        <div *ngIf="selected === 'Cook'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Cook' | translate"
            [form]="formGroup"
            name="Cook"
            key="Cook"
            textFieldName="DisplayName"
            apiName="Personnel/GetCooks">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader" *ngIf="isDepositReview">
        <div class="title" (click)="setSelectedFilter('Driver')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Driver" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Driver'"></i>
        </div>
        <div *ngIf="selected === 'Driver'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Delivery' | translate"
            [form]="formGroup"
            name="Delivery"
            key="Delivery"
            textFieldName="DisplayName"
            apiName="Personnel/GetDriverPersonnel">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)" isTabsetRouter="undifined">
      <ssg-tab
      *ngIf="isMultiBranch && BranchSaleComparisonSummary"
        class="review-tab"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparison' | translate">
        <section class="sale-box" *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparison' | translate)">
          <div class="second-box" *ngIf="!isDepositReview">
            <div (click)="hideChart = !hideChart" class="hidden-chart">
              <i class="icon-expand_more-o" [class.rotate]="hideChart"></i>
              <span
                [innerHTML]="
                  !hideChart
                    ? ('ClientApp.FrontOffice.Review.SalesReview.FailureDisplayChart' | translate)
                    : ('ClientApp.FrontOffice.Review.SalesReview.ShowChart' | translate)
                "
                class="chart-title"></span>
            </div>
            <div class="chartbox" [class.hide-chart]="hideChart" *ngIf="chartData?.length > 0">
              <div class="chart">
                <sepidz-chart-review
                  name="BranchSaleQuantityComparison"
                  class="mat-indigo"
                  keyColumn="Name"
                  [aggregateColumns]="['Value']"
                  [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.BranchSaleQuantityComparison' | translate]"
                  icon="local_offer"
                  [title]="'ClientApp.FrontOffice.Review.SalesReview.BranchSaleQuantityComparison' | translate"
                  [dataList]="chartData[0]?.NameValue"
                  areaName="RestaurantSale">
                </sepidz-chart-review>
              </div>
              <div class="chart">
                <sepidz-chart-review
                  name="BranchSaleAmountComparison"
                  class="mat-indigo"
                  keyColumn="Name"
                  [aggregateColumns]="['Value']"
                  [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.BranchSaleAmountComparison' | translate]"
                  icon="local_offer"
                  [title]="'ClientApp.FrontOffice.Review.SalesReview.BranchSaleAmountComparison' | translate"
                  [ratio]="1000000"
                  [dataList]="chartData[1]?.NameValue"
                  areaName="RestaurantSale">
                </sepidz-chart-review>
              </div>
            </div>
          </div>

          <div class="grid-box" [class.full-grid]="hideChart" [ngStyle]="isDepositReview ? { height: '80%' } : undefined">
            <div>
              <!-- <i class="icon-chevron-down"></i> -->
              <span class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparisonTitle" | translate }}</span>
            </div>
            <sepidz-grid-review
              *ngIf="GetBranchSaleComparisonColumns && GetBranchSaleComparisonColumns.length > 0"
              name="BranchSaleComparison"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparison' | translate"
              [apiName]="'SaleReview/BranchSaleComparison'"
              areaName="RestaurantSale"
              [groupable]="false"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetBranchSaleComparisonColumns"
              [filtering]="false"
              pathPreFix="SALE"
              displayNameColumn="BranchTitle"
              key="BranchId"
              aggregatesColumnName="BranchTitle,BranchId,TotalRounding, PackingPrice,TotalTip,TotalShippingCost,TotalCredit,TotalDebit,UsedCredit,TotalTax,TotalService,InvoiceCount,PayableTotal">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
      <ssg-tab
        class="review-tab"
        *hasPermission="[!isDepositReview ? 'RestaurantSale:SaleReview/Sale' : 'RestaurantSale:SaleReview/DepositSale', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Sale' | translate">
        <section class="sale-box" *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Sale' | translate)">
          <div fxLayout="row wrap" fxLayoutGap="8px">
            <div fxFlex class="kpi-container">
              <sepidz-kpi-review
                [name]="!isDepositReview ? 'AllSalesSummaryKpi' : 'AllDepositSummaryKpi'"
                [bundles]="!isDepositReview ? kpiBundles : kpiBundlesDeposit"
                [apiName]="!isDepositReview ? 'SaleReview/SalesSummaryKpi' : 'SaleReview/DepositSummaryKpi'">
              </sepidz-kpi-review>
            </div>
          </div>
          <div class="second-box" *ngIf="!isDepositReview">
            <div (click)="hideChart = !hideChart" class="hidden-chart">
              <i class="icon-expand_more-o" [class.rotate]="hideChart"></i>
              <span
                [innerHTML]="
                  !hideChart
                    ? ('ClientApp.FrontOffice.Review.SalesReview.FailureDisplayChart' | translate)
                    : ('ClientApp.FrontOffice.Review.SalesReview.ShowChart' | translate)
                "
                class="chart-title"></span>
            </div>
            <div class="chartbox" [class.hide-chart]="hideChart" *ngIf="chartData?.length > 0">
              <div class="chart">
                <sepidz-chart-review
                  name="SalesSummaryBySaleMethodAggregate"
                  class="mat-indigo"
                  keyColumn="Name"
                  [aggregateColumns]="['Value']"
                  [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
                  icon="local_offer"
                  [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryBySaleMethodAggregate' | translate"
                  [ratio]="1000000"
                  [dataList]="chartData[0]?.NameValue"
                  areaName="RestaurantSale">
                </sepidz-chart-review>
              </div>
              <div class="chart">
                <sepidz-chart-review
                  name="SalesSummaryByItemCategoryAggregate"
                  class="mat-indigo"
                  keyColumn="Name"
                  [aggregateColumns]="['Value']"
                  [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
                  icon="local_offer"
                  [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryByItemCategoryAggregate' | translate"
                  [ratio]="1000000"
                  [dataList]="chartData[1]?.NameValue"
                  areaName="RestaurantSale">
                </sepidz-chart-review>
              </div>
              <div class="chart">
                <sepidz-chart-review
                  name="SalesSummaryTotalByHourAggregate"
                  class="mat-indigo"
                  keyColumn="Name"
                  [aggregateColumns]="['Value']"
                  [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
                  icon="local_offer"
                  [ratio]="1000000"
                  [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByHourAggregate' | translate"
                  chartType="line"
                  [dataList]="chartData[2]?.NameValue"
                  areaName="RestaurantSale">
                </sepidz-chart-review>
              </div>
              <div class="chart">
                <sepidz-chart-review
                  name="SalesSummaryCountByHourAggregate"
                  class="mat-indigo"
                  keyColumn="Name"
                  [aggregateColumns]="['Value']"
                  [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
                  icon="local_offer"
                  [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByHourAggregate' | translate"
                  [dataList]="chartData[3]?.NameValue"
                  areaName="RestaurantSale">
                </sepidz-chart-review>
              </div>
            </div>
          </div>

          <div class="grid-box" [class.full-grid]="hideChart" [ngStyle]="isDepositReview ? { height: '80%' } : undefined">
            <div>
              <!-- <i class="icon-chevron-down"></i> -->
              <span class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.SaleMethodSalesSummaryList" | translate }}</span>
            </div>
            <sepidz-grid-review
              *ngIf="GetSaleMethodSummaryColumns && GetSaleMethodSummaryColumns.length > 0"
              name="SaleMethodSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SaleMethodSalesSummaryList' | translate"
              [apiName]="!isDepositReview ? 'SaleReview/SaleMethodSalesSummaryList' : 'SaleReview/SaleMethodDepositSummaryList'"
              areaName="RestaurantSale"
              [groupable]="false"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetSaleMethodSummaryColumns"
              [filtering]="false"
              pathPreFix="SALE"
              displayNameColumn="SaleMethodTitle"
              key="SaleMethodIds"
              aggregatesColumnName="TotalRounding, PackingPrice,TotalTip,TotalShippingCost,TotalCredit,TotalDebit,UsedCredit,TotalTax,TotalService,InvoiceCount,PayableTotal">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/MonthSales', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.MonthSales' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.MonthSales' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.MonthSalesSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetMmonthSummaryColumns && GetMmonthSummaryColumns.length > 0"
              name="MonthSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.MonthSalesSummaryList' | translate"
              apiName="SaleReview/MonthSalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetMmonthSummaryColumns"
              [filtering]="false"
              key="Months"
              defaultSortKey="MonthName"
              pathPreFix="SALE"
              displayNameColumn="MonthName"
              aggregatesColumnName="PayableTotal,InvoiceCount,TotalService,TotalTax,TotalDebit,TotalDiscount,TotalCredit,TotalShippingCost,TotalTip,TotalRounding">
            </sepidz-grid-review>
          </div>
          <div class="row chart-month">
            <sepidz-chart-review
              name="SalesSummaryTotalByMonthAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByMonthAggregate' | translate"
              [dataList]="chartData[0]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
            <sepidz-chart-review
              name="SalesSummaryCountByMonthAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByMonthAggregate' | translate"
              [dataList]="chartData[1]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
          </div>
          <div class="mt-xs ml-xs">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.DaySalesSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetDaySummaryColumns && GetDaySummaryColumns.length > 0"
              name="DaySalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.DaySalesSummaryList' | translate"
              apiName="SaleReview/DaySalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetDaySummaryColumns"
              [filtering]="false"
              key="Days"
              pathPreFix="SALE"
              [filterTextPrefix]="'ClientApp.FrontOffice.Review.SalesReview.Day' | translate"
              defaultSortKey="Day"
              displayNameColumn="Day"
              aggregatesColumnName="PayableTotal,InvoiceCount,TotalService,TotalTax,TotalDebit,TotalDiscount,TotalCredit,TotalShippingCost,TotalTip,TotalRounding">
            </sepidz-grid-review>
          </div>
          <div class="row chart-month">
            <sepidz-chart-review
              name="SalesSummaryTotalByDayAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByDayAggregate' | translate"
              [dataList]="chartData[2]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
            <sepidz-chart-review
              name="SalesSummaryCountByDayAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByDayAggregate' | translate"
              [dataList]="chartData[3]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
          </div>
          <div class="mt-xs ml-xs">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.HourSalesSummaryList" | translate }}</div>
            <sepidz-grid-review
              *ngIf="GetHourSummaryColumns && GetHourSummaryColumns.length > 0"
              name="HourSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.HourSalesSummaryList' | translate"
              apiName="SaleReview/HourSalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetHourSummaryColumns"
              [filtering]="false"
              key="Hours"
              displayNameColumn="Hour"
              pathPreFix="SALE"
              [filterTextPrefix]="'ClientApp.FrontOffice.Review.SalesReview.Clock' | translate"
              aggregatesColumnName="PayableTotal,TotalDebit,TotalService,TotalTax,TotalCredit,TotalDiscount,TotalShippingCost,TotalTip,UsedCredit,PaymentToAcc, TotalRounding, InvoiceCount">
            </sepidz-grid-review>
          </div>
          <div class="row chart-month">
            <sepidz-chart-review
              name="SalesSummaryTotalByHourAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByDayAggregate' | translate"
              [dataList]="chartData[4]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
            <sepidz-chart-review
              name="SalesSummaryCountByHourAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByMonthAggregate' | translate"
              [dataList]="chartData[5]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/UserSales', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Users' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Users' | translate)">
          <section class="mr-xs ml-xs mt-xs mb-xs">
            <div class="mt-xs ml-xs">
              <div class="title-tab" *ngIf="GetUserSummaryColumns && GetUserSummaryColumns.length > 0 && hasUserSalesSummary">
                {{ "ClientApp.FrontOffice.Review.SalesReview.UserSalesSummaryList" | translate }}
              </div>
              <sepidz-grid-review
                *ngIf="GetUserSummaryColumns && GetUserSummaryColumns.length > 0 && hasUserSalesSummary"
                name="UserSalesSummaryList"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.UserSalesSummaryList' | translate"
                apiName="SaleReview/UserSalesSummaryList"
                areaName="RestaurantSale"
                [unSortableFilterable]="unSortableFilterable"
                [columns]="GetUserSummaryColumns"
                [filtering]="false"
                pathPreFix="SALE"
                displayNameColumn="UserDisplayName"
                key="UserListIds"
                aggregatesColumnName="TotalRounding,TotalTip,TotalShippingCost,TotalCredit,TotalDiscount,TotalDebit,TotalTax,TotalService,InvoiceCount,PayableTotal">
              </sepidz-grid-review>
            </div>
            <div class="row chart-month" *ngIf="hasUserSalesSummary">
              <sepidz-chart-review
                name="SalesSummaryTotalByUserAggregate"
                class="mat-indigo"
                keyColumn="Name"
                [aggregateColumns]="['Value']"
                [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
                icon="local_offer"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByMonthAggregate' | translate"
                [dataList]="chartData[0]?.NameValue"
                areaName="RestaurantSale">
              </sepidz-chart-review>
              <sepidz-chart-review
                name="SalesSummaryCountByUserAggregate"
                class="mat-indigo"
                keyColumn="Name"
                [aggregateColumns]="['Value']"
                [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
                icon="local_offer"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByMonthAggregate' | translate"
                [dataList]="chartData[1]?.NameValue"
                areaName="RestaurantSale">
              </sepidz-chart-review>
            </div>
            <div class="mt-xs ml-xs">
              <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.DriverSalesSummaryList" | translate }}</div>
              <sepidz-grid-review
                *ngIf="GetDriverSummaryColumns && GetDriverSummaryColumns.length > 0"
                name="DriverSalesSummaryList"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.DriverSalesSummaryList' | translate"
                apiName="SaleReview/DriverSalesSummaryList"
                areaName="RestaurantSale"
                [unSortableFilterable]="unSortableFilterable"
                [columns]="GetDriverSummaryColumns"
                [filtering]="true"
                pathPreFix="SALE"
                displayNameColumn="DriverTitle"
                key="DriverIds"
                aggregatesColumnName="TotalRounding,TotalTip,TotalShippingCost,TotalCredit,TotalDiscount,TotalDebit,TotalTax,TotalService,InvoiceCount,PayableTotal,TotalCourierShippingCost">
              </sepidz-grid-review>
            </div>
            <div class="row chart-month">
              <sepidz-chart-review
                name="SalesSummaryTotalByDriverAggregate"
                class="mat-indigo"
                keyColumn="Name"
                [aggregateColumns]="['Value']"
                [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
                icon="local_offer"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByDayAggregate' | translate"
                [dataList]="chartData[2]?.NameValue"
                areaName="RestaurantSale">
              </sepidz-chart-review>
              <sepidz-chart-review
                name="SalesSummaryCountByDriverAggregate"
                class="mat-indigo"
                keyColumn="Name"
                [aggregateColumns]="['Value']"
                [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
                icon="local_offer"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByDayAggregate' | translate"
                [dataList]="chartData[3]?.NameValue"
                areaName="RestaurantSale">
              </sepidz-chart-review>
            </div>
            <div class="mt-xs ml-xs">
              <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.WaiterSalesSummaryList" | translate }}</div>
              <sepidz-grid-review
                *ngIf="GetWaiterSummaryColumns && GetWaiterSummaryColumns.length > 0"
                name="WaiterSalesSummaryList"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.WaiterSalesSummaryList' | translate"
                apiName="SaleReview/WaiterSalesSummaryList"
                areaName="RestaurantSale"
                [unSortableFilterable]="unSortableFilterable"
                [columns]="GetWaiterSummaryColumns"
                [filtering]="false"
                pathPreFix="SALE"
                displayNameColumn="WaiterTitle"
                key="WaiterListIds"
                aggregatesColumnName="TotalRounding,TotalTip,TotalShippingCost,TotalCredit,TotalDiscount,TotalDebit,TotalTax,TotalService,InvoiceCount,PayableTotal">
              </sepidz-grid-review>
            </div>
            <div class="row chart-month">
              <sepidz-chart-review
                name="SalesSummaryTotalByWaiterAggregate"
                class="mat-indigo"
                keyColumn="Name"
                [aggregateColumns]="['Value']"
                [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
                icon="local_offer"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByMonthAggregate' | translate"
                [dataList]="chartData[4]?.NameValue"
                areaName="RestaurantSale">
              </sepidz-chart-review>
              <sepidz-chart-review
                name="SalesSummaryCountByWaiterAggregate"
                class="mat-indigo"
                keyColumn="Name"
                [aggregateColumns]="['Value']"
                [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
                icon="local_offer"
                [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByMonthAggregate' | translate"
                [dataList]="chartData[5]?.NameValue"
                areaName="RestaurantSale">
              </sepidz-chart-review>
            </div>
          </section>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/ItemCategorySales', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.GoodsGroup' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.GoodsGroup' | translate)">
          <div class="mt-xs ml-xs">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.ItemCategorySalesSummaryList" | translate }}</div>
            <sepidz-grid-review
              *ngIf="GetItemCategorySummaryColumns && GetItemCategorySummaryColumns.length > 0"
              name="ItemCategorySalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.ItemCategorySalesSummaryList' | translate"
              apiName="SaleReview/ItemCategorySalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetItemCategorySummaryColumns"
              [filtering]="false"
              key="ItemCategoryIds"
              pathPreFix="SALE"
              displayNameColumn="ItemCategoryTitle"
              aggregatesColumnName="TotalPriceInclServiceInclTax,TotalDiscount,TotalTax,TotalService,InvoiceCount,TotalPrice">
            </sepidz-grid-review>
          </div>
          <div class="row chart-month">
            <sepidz-chart-review
              name="SalesSummaryTotalByItemCategoryAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByMonthAggregate' | translate"
              [dataList]="chartData[0]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
            <sepidz-chart-review
              name="SalesSummaryCountByItemCategoryAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByMonthAggregate' | translate"
              [dataList]="chartData[1]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/DepositSalesSummaryList', 'Same', isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.DepositSales' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.DepositSales' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.DepositSalesSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="depositSalesSummaryColumns && depositSalesSummaryColumns.length > 0"
              name="DepositSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.DepositSalesSummaryList' | translate"
              apiName="SaleReview/DepositSalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterableDeposit"
              [columns]="depositSalesSummaryColumns"
              [filtering]="false"
              key="InvoiceIds"
              defaultSortKey="InvoiceCode"
              pathPreFix="SALE"
              displayNameColumn="CustomerName"
              aggregatesColumnName="PayableTotal,ServicesAmount,Remain,DepositAmount,ShippingCost">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        *hasPermission="['RestaurantSale:SaleReview/InvoiceItemDepositSummaryList', 'Same', isDepositReview]"
        class="review-tab"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.DepositDetail' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.DepositDetail' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.DepositDetail" | translate }}</div>
            <sepidz-grid-review
              *ngIf="invoiceItemSummaryColumns && invoiceItemSummaryColumns.length > 0"
              name="InvoiceItemDepositSummaryList"
              key="FactorDetails"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.DepositDetail' | translate"
              apiName="SaleReview/InvoiceItemDepositSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              displayNameColumn="ItemNumber"
              pathPreFix="SALE"
              [columns]="invoiceItemSummaryColumns"
              aggregatesColumnName="Quantity,UnitPrice,TotalTax,TotalService,TotalDiscount,TotalPriceInclServiceInclTax,TotalPrice"
              [filtering]="false">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="[!isDepositReview ? 'RestaurantSale:SaleReview/PersonnelSale' : 'RestaurantSale:SaleReview/DepositItem', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Item' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Item' | translate)">
          <div class="mt-xs ml-xs" [class.h-100]="isDepositReview">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.ItemSalesSummaryList" | translate }}</div>
            <sepidz-grid-review
              *ngIf="GetItemSummaryColumns && GetItemSummaryColumns.length > 0"
              name="ItemSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.ItemSalesSummaryList' | translate"
              [apiName]="!isDepositReview ? 'SaleReview/ItemSalesSummaryList' : 'SaleReview/ItemDepositSummaryList'"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetItemSummaryColumns"
              [filtering]="false"
              key="ItemIds"
              defaultSortKey="Number"
              pathPreFix="SALE"
              displayNameColumn="ItemTitle"
              aggregatesColumnName="TotalPriceInclServiceInclTax,TotalDiscount,TotalTax,TotalService,InvoiceCount,TotalPrice,UnitPrice">
            </sepidz-grid-review>
          </div>
          <div class="row chart-month" *ngIf="!isDepositReview">
            <sepidz-chart-review
              name="SalesSummaryTotalByItemAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Amount' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryTotalByDayAggregate' | translate"
              [dataList]="chartData[0]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
            <sepidz-chart-review
              name="SalesSummaryCountByItemAggregate"
              class="mat-indigo"
              keyColumn="Name"
              [aggregateColumns]="['Value']"
              [seriesTitle]="['ClientApp.FrontOffice.Review.SalesReview.Number' | translate]"
              icon="local_offer"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SalesSummaryCountByDayAggregate' | translate"
              [dataList]="chartData[1]?.NameValue"
              areaName="RestaurantSale">
            </sepidz-chart-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/PersonnelServicesSummaryList', 'Same', isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.PersonnelServices' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.PersonnelServices' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.PersonnelServices" | translate }}</div>
            <sepidz-grid-review
              *ngIf="personnelServicesSummaryColumns && personnelServicesSummaryColumns.length > 0"
              name="PersonnelServicesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.PersonnelServicesSummaryList' | translate"
              apiName="SaleReview/PersonnelServicesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="personnelServicesSummaryColumns"
              [filtering]="false"
              defaultSortKey="PersonnelName"
              pathPreFix="SALE"
              aggregatesColumnName="Amount">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/DepositSummaryList', 'Same', isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Deposit' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Deposit' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.DepositSummaryList" | translate }}</div>
            <sepidz-grid-review
              *ngIf="depositSummaryColumns && depositSummaryColumns.length > 0"
              name="DepositSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.DepositSummaryList' | translate"
              apiName="SaleReview/DepositSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="depositSummaryColumns"
              [filtering]="false"
              defaultSortKey="InvoiceCode"
              pathPreFix="SALE"
              aggregatesColumnName="Amount">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/InvoiceSalesSummaryList', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Factor' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Factor' | translate)">
          <div class="mt-xs ml-xs" class="box-heigt">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.InvoiceSalesSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetInvoiceSummaryColumns && GetInvoiceSummaryColumns.length > 0"
              name="InvoiceSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceSalesSummaryList' | translate"
              apiName="SaleReview/InvoiceSalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetInvoiceSummaryColumns"
              [filtering]="true"
              key="InvoiceIds"
              displayNameColumn="Code"
              pathPreFix="SALE"
              [filterTextPrefix]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceNo' | translate"
              aggregatesColumnName="PayableTotal,TotalDebit,TotalService,TotalTax,TotalCredit,TotalDiscount,TotalShippingCost,TotalTip,UsedCredit,Karmozd,PaymentToAcc">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/InvoiceItemSalesSummaryList', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.FactorDetail' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.FactorDetail' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.InvoiceItemSalesSummaryList" | translate }}</div>
            <sepidz-grid-review
              *ngIf="GetInvoiceItemSummaryColumns && GetInvoiceItemSummaryColumns.length > 0"
              name="InvoiceItemSalesSummaryList"
              key="FactorDetails"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceItemSalesSummaryList' | translate"
              apiName="SaleReview/InvoiceItemSalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              displayNameColumn="ItemNumber"
              pathPreFix="SALE"
              [columns]="GetInvoiceItemSummaryColumns"
              [filtering]="false"
              aggregatesColumnName="TotalPriceInclServiceInclTax,TotalTax,TotalService,TotalDiscount,TotalPrice,Quantity,UnitPrice">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/PersonnelSale', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.AdditiveAndDescription' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.AdditiveAndDescription' | translate)">
          <div class="additive-grid mt-xs ml-xs">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.InvoiceItemAdditiveSalesSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetItemAdditiveSummaryColumns && GetItemAdditiveSummaryColumns.length > 0"
              name="InvoiceItemAdditiveSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceItemAdditiveSalesSummaryList' | translate"
              apiName="SaleReview/InvoiceItemAdditiveSalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetItemAdditiveSummaryColumns"
              [filtering]="false"
              key="AdditiveIds"
              defaultSortKey="Number"
              pathPreFix="SALE"
              displayNameColumn="ItemAdditiveTitle"
              aggregatesColumnName="UnitPrice ,TotalAdditive">
            </sepidz-grid-review>
          </div>

          <div class="description-grid mt-xs ml-xs">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.InvoiceItemDescriptionSalesSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetItemDescriptionSummaryColumns && GetItemDescriptionSummaryColumns.length > 0"
              name="InvoiceItemDescriptionSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceItemDescriptionSalesSummaryList' | translate"
              apiName="SaleReview/InvoiceItemAdditiveSalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetItemDescriptionSummaryColumns"
              [filtering]="false"
              key="DescriptionIds"
              defaultSortKey="Number"
              pathPreFix="SALE"
              displayNameColumn="ItemDescriptionTitle">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
      <ssg-tab 
      class="review-tab"
      *hasPermission="['RestaurantSale:SaleReview/PersonnelSale', 'Same', !isDepositReview]"
      [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.ItemsNumber' | translate">
      <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.ItemsNumber' | translate)">
        <div class="mt-xs ml-xs" class="box-heigt">
          <div class="title-tab">
            {{ "ClientApp.FrontOffice.Review.SalesReview.ItemsNumber" | translate }}
          </div>
          <sepidz-grid-review
            *ngIf="GetItemsNumberSummaryColumns && GetItemsNumberSummaryColumns.length > 0"
            name="ItemsNumberSalesSummaryList"
            [title]="'ClientApp.FrontOffice.Review.SalesReview.ItemsNumber' | translate"
            apiName="SaleReview/ItemsNumberSalesSummaryList"
            areaName="RestaurantSale"
            [columns]="GetItemsNumberSummaryColumns"
            [filtering]="true"
            key="ItemIds"
            defaultSortKey="Number"
            pathPreFix="SALE"
            displayNameColumn="ItemTitle"
            aggregatesColumnName="InvoiceCount">
          </sepidz-grid-review>
        </div>
      </section>
      </ssg-tab>      
      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/PersonnelSale', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.SummarySaleQuantity' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.SummarySaleQuantity' | translate)">
          <div class="factor-grid mt-xs ml-xs">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.SummarySaleQuantity" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetSaleQuantitySummaryColumns && GetSaleQuantitySummaryColumns.length > 0"
              name="SaleQuantitySummaryList"
              apiName="SaleReview/SaleQuantitySalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SaleQuantitySummaryList' | translate"
              areaName="RestaurantSale"
              [columns]="GetSaleQuantitySummaryColumns"
              (onRowSelected)="onSaleQuantityRowSelected($event)"
              [filtering]="true"
              key="InvoiceIds"
              displayNameColumn="Code"
              pathPreFix="SALE">
            </sepidz-grid-review>
          </div>

          <div class="factor-detail-grid mt-xs ml-xs">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.FactorDetail" | translate }}</div>
            <sepidz-grid-review
              *ngIf="GetSaleQuantitySummaryColumns && GetSaleQuantitySummaryColumns.length > 0"
              name="FactorDetail"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.FactorDetail' | translate"
              areaName="RestaurantSale"
              [columns]="GetInvoiceItemSummaryColumns"
              [customDataList]="customDataList"
              [filtering]="true"
              key="InvoiceIds"
              displayNameColumn="Code"
              pathPreFix="SALE">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/InvoiceScheduleList', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceSchedule' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.InvoiceSchedule' | translate)">
          <div class="mt-xs ml-xs" class="box-heigt">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.InvoiceSchedule" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetInvoiceScheduleListColumns && GetInvoiceScheduleListColumns.length > 0"
              name="InvoiceScheduleList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceSchedule' | translate"
              apiName="SaleReview/InvoiceScheduleList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterableScheduleList"
              [columns]="GetInvoiceScheduleListColumns"
              [filtering]="true"
              key="InvoiceIds"
              displayNameColumn="Code"
              pathPreFix="SALE"
              [filterTextPrefix]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceNo' | translate">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/PersonnelSale', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.UserSettlementSummaryList' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.UserSettlementSummaryList' | translate)">
          <div class="mt-xs ml-xs">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.UserSettlementSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetUserSettlementSummaryColumns && GetUserSettlementSummaryColumns.length > 0"
              name="UserSettlementSummaryList"
              key="UserSettlementSummaryLists"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.UserSettlementSummaryList' | translate"
              apiName="SaleReview/UserSettlementSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetUserSettlementSummaryColumns"
              [filtering]="false"
              (onRowSelected)="onRowSelected($event)"
              pathPreFix="SALE"
              displayNameColumn="DisplayName">
            </sepidz-grid-review>
          </div>
          <div *ngIf="ReceiptPaymentColumns?.length > 0">
            <kgrid
              label="detail"
              areaName="RestaurantSale"
              [isAdd]="false"
              [isEdit]="false"
              [isDelete]="false"
              [groupable]="false"
              [noToolBar]="true"
              pathPreFix="SALE"
              [columns]="ReceiptPaymentColumns"
              [dataList]="UserSettlementReceipt">
            </kgrid>
          </div>
          <div class="mt-xs ml-xs">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.DriverSettlementSummaryList" | translate }}</div>
            <sepidz-grid-review
              *ngIf="GetDriverSettlementSummaryColumns && GetDriverSettlementSummaryColumns.length > 0"
              name="DriverSettlementSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.DriverSettlementSummaryList' | translate"
              apiName="SaleReview/DriverSettlementSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetDriverSettlementSummaryColumns"
              [filtering]="false"
              pathPreFix="SALE"
              (onRowSelected)="onDriverRowSelected($event)">
            </sepidz-grid-review>
          </div>
          <div *ngIf="ReceiptPaymentColumns?.length > 0">
            <kgrid
              label="detail"
              areaName="RestaurantSale"
              [isAdd]="false"
              [isEdit]="false"
              [isDelete]="false"
              [groupable]="false"
              [noToolBar]="true"
              pathPreFix="SALE"
              [columns]="ReceiptPaymentColumns"
              [dataList]="DriverSettlementReceipt">
            </kgrid>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/PaymentMethodSaleSummaryList', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.PaymentMethodSaleSummaryList' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.PaymentMethodSaleSummaryList' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.PaymentMethodSaleSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetPaymentMethodSaleSummaryColumns && GetPaymentMethodSaleSummaryColumns.length > 0"
              name="PaymentMethodSaleSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.PaymentMethodSaleSummaryList' | translate"
              apiName="SaleReview/PaymentMethodSaleSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              pathPreFix="SALE"
              [columns]="GetPaymentMethodSaleSummaryColumns"
              [filtering]="true"
              key="PaymentMethodIds"
              displayNameColumn="Title"
              aggregatesColumnName="Remain,ReceiptAmount,PaymentAmount">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:SaleReview/ReceiptPaymentSummaryList', 'Same', !isDepositReview]"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.ReceiptPaymentSummaryList' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.ReceiptPaymentSummaryList' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.ReceiptPaymentSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="GetReceiptPaymentSummaryColumns && GetReceiptPaymentSummaryColumns.length > 0"
              name="ReceiptPaymentSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.ReceiptPaymentSummaryList' | translate"
              apiName="SaleReview/ReceiptPaymentSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              pathPreFix="SALE"
              defaultSortKey="Code"
              [columns]="GetReceiptPaymentSummaryColumns"
              [filtering]="false"
              valueNameColumn="Code"
              aggregatesColumnName="ReceiptAmount">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
